import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
export var SECTION_PADDING_BREAKPOINT = 1232;
export var Section = function(props) {
    return /*#__PURE__*/ _jsx(BackgroundColor, {
        $color: props.color,
        children: /*#__PURE__*/ _jsx(MaxWidthContainer, {
            $mobilePadding: props.mobilePadding,
            children: props.children
        })
    });
};
var BackgroundColor = styled.div.withConfig({
    componentId: "sc-3b6d0ae6-0"
})([
    "background-color:",
    ";"
], function(props) {
    return props.$color;
});
var MaxWidthContainer = styled(Column).withConfig({
    componentId: "sc-3b6d0ae6-1"
})([
    "width:100%;margin:0 auto;max-width:1168px;padding:",
    ";@media (min-width:",
    "px){padding:0;}",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], getSpacing(0, "5x"), SECTION_PADDING_BREAKPOINT, responsiveMediaQueries.tablet, function(props) {
    var _props_$tabletPadding;
    return (_props_$tabletPadding = props.$tabletPadding) !== null && _props_$tabletPadding !== void 0 ? _props_$tabletPadding : getSpacing(0, "3x");
}, responsiveMediaQueries.mobile, function(props) {
    var _props_$mobilePadding;
    return (_props_$mobilePadding = props.$mobilePadding) !== null && _props_$mobilePadding !== void 0 ? _props_$mobilePadding : getSpacing(0, "2x");
});
